<div
    class="client-address"
    style="
                        /*border: 1px solid #4444;*/
                        /*padding: 12px;*/
                        width: 95%;
                        border-radius: 6px;
                        margin: 10px;
                        font-size: 14px;
                    "
>
    <slot />
</div>
